// MySQL role.roledescription values
export const ROLE_EXTERNAL_AGENCY = 'External Agency';
export const ROLE_HOSPITAL_USER = 'Hospital User';
export const ROLE_CARE_COORDINATOR = 'Care Coordinator';

// MySQL refr_cstm_job_title.description values
export const JOB_TITLE_CMHC_BH_CM = 'CMHC BH Care Manager';

export const SUD_SMI_AUTOMATIC_ACCESS_MESSAGE = `${ROLE_EXTERNAL_AGENCY} users with a Job Title of ${JOB_TITLE_CMHC_BH_CM} will be automatically given access to the SUD/SMI Program Dashboard. Please ensure you have selected the correct Job Title and Role.`;
